import AppHeader from '@/components/partials/AppHeader/AppHeader.vue';
import {mapState} from "vuex";

export default {
  name: 'login',
  components: {
    AppHeader,
  },
  mounted(){
    // console.log('近來 login page 了');
    const vm = this;
    vm.$store.dispatch('sign_up/checkIsPending', {
      line_uuid: vm.userInfo.userId,
    }).then((res) => {
      if (res.data.message !== '查無資料') {
        vm.$router.push({ name: 'sign_up_pending'})
      }
    });
  },
  methods:{
    //- Line Login
    loginHandler: function() {
      let vm = this;
      vm.$store.dispatch('login/linelogin');
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
    }),
  }
}
